import * as yup from "yup";
import {  phoneCheck,passwordRegex } from '../../common/regex';
export const validationSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  organization: yup.string().required("Organization is required"),
  emailId: yup.string().email("Invalid email format").required("Email is required"),
  password: yup
  .string()
  .required("Password is required")
  .matches(
    passwordRegex,
    "Password must be 8–12 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character."
  ),
  confirmPassword: yup.string()
    .oneOf([yup.ref('password'), undefined], "Passwords must match")
    .required("Confirm password is required"),

  mobileNumber: yup.string().required("Mobile Number is required").matches(phoneCheck, "Please enter a valid Mobile number").required("Mobile number is required"),
});